module.exports = __webpack_public_path__ + "static/media/bitcoin_script_bitcoin-studio.6ad9693b.jpg";